import { RoleResponse, RoleSearchOrderBy, SortOrder } from 'api/minside';
import { rolesClient } from 'api/MinSideClients';
import { SelectOption, useFetch } from 'common.ui';

type FetchedRoles = [SelectOption[] | undefined, RoleResponse[] | undefined];
export type RolesResult = [SelectOption[] | undefined, RoleResponse[] | undefined, boolean];

export function useRoles(applicationId?: string | null, searchAllApplicationsIfNull?: boolean | null, onlyEndUserAssignable?: boolean | null): RolesResult {
  const fetchAllRoles = async (): Promise<FetchedRoles> => {
    if (!applicationId && searchAllApplicationsIfNull === false) {
      return [undefined, undefined];
    }
    const roles = await rolesClient.apiRolesGet({
      pageNumber: 1,
      pageSize: 9999,
      sortOrder: SortOrder.Ascending,
      orderField: RoleSearchOrderBy.Name,
      applicationId: applicationId ?? undefined,
      onlyEndUserAssignable: onlyEndUserAssignable ?? undefined
    });

    if (!roles.data) {
      return [undefined, undefined];
    }

    const options = roles.data.map((d: RoleResponse) => {
      return {
        id: d.roleId?.toString(),
        text: d.name
      } as SelectOption;
    });

    return [options, roles.data];
  };

  const [fetchedRoles, isLoading] = useFetch<FetchedRoles>(() => fetchAllRoles(), [undefined, undefined], false, [
    applicationId,
    searchAllApplicationsIfNull,
    onlyEndUserAssignable
  ]);

  return [fetchedRoles[0], fetchedRoles[1], isLoading];
}
